import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AssignDialogComponent } from 'src/app/common/assign-dialog/assign-dialog.component';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { printMessage } from 'src/app/constants/service.constants';
import { RouteComponent } from 'src/app/common/route/route.component';
import { IstUserInstructionsModalComponent } from './ist-user-instructions-modal/ist-user-instructions-modal.component';
import { WithdrawComponent } from 'src/app/common/withdraw/withdraw.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { IstDataShareService } from '../../services/ist/ist-datashare.service';
import { DateObject, IST_APP, ModuleMenu } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { UserService } from 'src/app/services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Organization } from 'src/app/models/um/organization';

@Component({
  selector: 'app-ist-my-applications',
  templateUrl: './ist-my-applications.component.html',
  styleUrls: ['./ist-my-applications.component.scss']
})
export class IstMyApplicationsComponent implements OnInit {

  gridApi: GridApi;
  columnDefs: any[];
  operations: any[];
  tempoperations: any[];
  rowData;
  advanceSearch: any;
  selectedRow;
  caseDetails;
  studyType: any[];
  requestType: any[];
  StatusList: any[];
  TherapeuticAreaList:any[];
  productList:any[];
  IStApplicationsSearch: UntypedFormGroup;
  istapp: IST_APP;
  maxDate:Date = new Date() ;
  menudata: ModuleMenu;
  userType: string = "";  
  isProduct:boolean=false;
  myDate = new Date();  
  Instruction_Status:boolean;
  isHadPermission:boolean = false;
  yesterday = new Date(this.myDate.setDate(new Date().getDate()+1));
  year = this.yesterday.getFullYear();
  moth = this.yesterday.getMonth() + 1;
  Day = this.yesterday.getDate();
  istDisplayName:string='';
  
  //SDates:any;
  //EDates:any;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private dataShare: IstDataShareService,
    private commonService: CommonService,
    private header: HeadService,
    private userService: UserService

  ) {

  }
  orgdetails : Organization
  ngOnInit() {

    this.requestType = [{ "value": "", "label": "All" }, { "value": "1", "label": "Fund" }, { "value": "2", "label": "Product" }, { "value": "3", "label": "Both" }];
    this.StatusList= [{ "value": "", "label": "All" },{ "value": "1", "label": "Draft" }, { "value": "2", "label": "Submitted" }, { "value": "3", "label": "Review Ongoing" }, { "value": "4", "label": "Accepted" }, { "value": "5", "label": "Closed" }, { "value": "6", "label": "Rejected" }, { "value": "7", "label": "On-hold" }, { "value": "8", "label": "Withdrawn" }, { "value": "9", "label": "Discarded" }];
    this.userType = this.userService.getUserType();
    let orgcode = this.userService.getOrgCode();
 this.orgdetails  = this.commonService.getOrganizationObject(orgcode);
    this.IStApplicationsSearch = new UntypedFormGroup({
      Title: new UntypedFormControl(""),
      PhysicianName: new UntypedFormControl(""),
      TherapeuticArea: new UntypedFormControl(""),
      RequestType: new UntypedFormControl(""),
      Product: new UntypedFormControl(""),
      StudyType: new UntypedFormControl(""),
      Assignedto: new UntypedFormControl(""),
      Status: new UntypedFormControl(""),
      StartDate:new UntypedFormControl(null),
      EndDate: new UntypedFormControl(null),  
      StartDateO : new UntypedFormControl(null),
      EndDateO:new UntypedFormControl(null) 

    });
    
    if (this.userType === "E") {
      this.tempoperations = [
        {
          "name": "New Application",
          "id": "add"
        }
      ]
      
    }
    else
      this.tempoperations = [];
   
    this.operations = this.tempoperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } :
       { name: operation.name, callback: this[operation.id], self: this }
    });
    this.advanceSearch ={
      "fields": [
        {
          "label": "Title",
          "field": "title",
          "type": "text"
        },
        {
          "label": "Physician Name",
          "field": "PhysicianName",
          "type": "text"
        },
        {
          "label": "Therapeutic Area",
          "field": "TherapeuticArea",
          "type": "dropdown",
          "options":this.TherapeuticAreaList,
        },
        {
          "label": "Study Type",
          "field": "StudyType",
          "type": "dropdown",
          "options": this.studyType,
        },
        {
          "label": "Request Type",
          "field": "RequestType",
          "type": "dropdown",
          "options": this.requestType,
        },
        {
          "label": "Product",
          "field": "Product",
          "type": "dropdown",
          "options": this.productList,
        },
        {
          "label": "Status",
          "field": "status",
          "type": "dropdown",
          "options": this.StatusList,
        }
      ],
      "filters": [
        {
          "label": "New Applications in last one week",
          "filter_key": "unique_key_1",
          "criteria": ""
        },
        {
          "label": "New Applicaitons in last one month",
          "filter_key": "unique_key_2",
          "criteria": ""
        },
        {
          "label": "New Applications in last one quarter",
          "filter_key": "unique_key_3",
          "criteria": ""
        },
        {
          "label": "New Applications in last one year",
          "filter_key": "unique_key_4",
          "criteria": ""
        }
      ]
    };
    if (this.userType == 'I')
    {
      let hadeditPermission = this.commonService.getScreenPermission("202","E");
      if(hadeditPermission)
      {
        this.isHadPermission=true;
      }
      this.columnDefs= [
        {
          "headerName": "Application ID",
          "field": "APPLICATION_CODE"
        },
        {
          "headerName": "Physician Name",
          "field": "PhysicianName",
        },
        {
          "headerName": "Therapeutic Area",
          "field": "THERAPEUTIC_AREA_NAME"
        },
        {
          "headerName": "Request Type",
          "field": "REQUEST_TYPE_NAME"
        },
        {
          "headerName": "Product",
          "field": "PRODUCT_NAME"
        },
        {
          "headerName": "Study Type",
          "field": "StudyType"
        },
        {
          "headerName": "Status",
          "field": "STATUSStr"
        },
        {
          "headerName": "Submitted On",
          "field": "SubmittedOnStr"
        },
        {
          "headerName": "Last Updated On",
          "field": "LastUpdatedStr"
        }
      ];
      this.caseDetails=[
      {
        "caseSet" : {
          "caseHeading": "General",
            "caseData" : [
              {
                "label": "Application ID",
                "value": "APPLICATION_CODE"
              },
              {
                "label": "Physician Name",
                "value": "PhysicianName"
              },
              {
                "label": "Study Sponsored",
                "value": "StudySponceredBy"
              },
              {
                "label": "Therapeutic Area",
                "value": "THERAPEUTIC_AREA_NAME"
              },
              {
                "label": "Request Type",
                "value": "REQUEST_TYPE_NAME"
              },
              {
                "label": "Product",
                "value": "PRODUCT_NAME"
              },
              {
                "label": "Study Type",
                "value": "StudyType"
              },
              {
                "label": "Status",
                "value": "STATUSStr"
              },
              {
                "label": "Submitted On",
                "value": "SubmittedOnStr"
              },
              {
                "label": "Last Updated On",
                "value": "LastUpdatedStr"
              },
              {
                "label": "IRB Name",
                "value": "IRBName"
              },
              {
                "label": "#Total Requests",
                "value": "totalRequests"
              },
              {
                "label": "#Closed Requests",
                "value": "closedRequests"
              }
            ]
  
        }
      }
    ]}
    else if (this.userType == 'E')
    {
      this.isHadPermission=true;
      this.columnDefs= [
        {
          "headerName": "Application ID",
          "field": "APPLICATION_CODE"
        },
        {
          "headerName": "Therapeutic Area",
          "field": "THERAPEUTIC_AREA_NAME"
        },
        {
          "headerName": "Request Type",
          "field": "REQUEST_TYPE_NAME"
        },
        {
          "headerName": "Product",
          "field": "PRODUCT_NAME"
        },
        {
          "headerName": "Study Type",
          "field": "StudyType"
        },
        {
          "headerName": "Status",
          "field": "STATUSStr"
        },
        {
          "headerName": "Submitted On",
          "field": "SubmittedOnStr"
        },
        {
          "headerName": "Assigned to",
          "field": "AssignedTo"
        },
        {
          "headerName": "Last Updated On",
          "field": "LastUpdatedStr"
        }
      ];
      this.caseDetails=[
        {
          "caseSet" : {
            "caseHeading": "General",
              "caseData" : [
                {
                  "label": "Application ID",
                  "value": "APPLICATION_CODE"
                },
                {
                  "label": "Study Sponsored",
                  "value": "StudySponceredBy"
                },
                {
                  "label": "Therapeutic Area",
                  "value": "THERAPEUTIC_AREA_NAME"
                },
                {
                  "label": "Request Type",
                  "value": "REQUEST_TYPE_NAME"
                },
                {
                  "label": "Product",
                  "value": "PRODUCT_NAME"
                },
                {
                  "label": "Study Type",
                  "value": "StudyType"
                },
                {
                  "label": "Status",
                  "value": "STATUSStr"
                },
                {
                  "label": "Submitted On",
                  "value": "SubmittedOnStr"
                },
                {
                  "label": "Last Updated On",
                  "value": "LastUpdatedStr"
                },
                {
                  "label": "IRB Name",
                  "value": "IRBName"
                },
                {
                  "label": "#Total Requests",
                  "value": "totalRequests"
                },
                {
                  "label": "#Closed Requests",
                  "value": "closedRequests"
                }
              ]
    
          }
        }
      ]
    };

    this.getSummaryData();
  }

  requestTypeChange(event) {
   let requestType= event.value;
   if (requestType != 1){ this.isProduct = false}
   else {this.isProduct = true}
  }
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

   onRowDoubleClicked(event) {

    this.summaryService.getISTApplicationSummary("api/common/getistapp/" + event.data["ID"]).subscribe(data => {
      this.commonService.removeLeftMenu();
      this.istapp = data;
      this.commonService.appId = data.ID;
      this.commonService.ScreenID=data.ID;
      this.commonService.setISTApp(this.istapp);
      this.menudata = new ModuleMenu();
      this.menudata.module = "IST";
      this.menudata.operation = "Edit";
      this.menudata.appId = this.istapp.ID;
      this.menudata.screenID = this.istapp.ID;
      if (this.istapp.STATUS === null)
        this.menudata.formstate = "Draft";
      else
        this.menudata.formstate = this.getStatus(this.istapp.STATUS);
      this.commonService.setModluleMenu(this.menudata);

      this.header.setHeader(this.menudata);
      this.dataShare.setApplicationID(event.data["ID"]);
      this.router.navigate(['/home/ist/my-applications/application-ext/:' + event.data['ID'] + '/general_information_request'], { skipLocationChange: true, queryParams: { id: event.data['ID'], app_ext: true, module: "ist",submodule:"ist", screen_type: "my-applications" } })
    });

    //let url = location.href.split('/');
    //window.open(url[0] + '//' + url[2] + '/home/ist/my-applications/application-ext/:' + this.selectedRow['id']+'/general_information_request');
  } 

  getStatus(statusnum: number): string {
    let status = "";
    switch (statusnum) {
      case 0:
        status = "Draft";
        break;
      case 1:
        status = "Draft";
        break;
      case 2:
        status = "Submitted";
        break;
      case 3:
        status = "Review Ongoing";
        break;
      case 4:
        status = "Accepted";
        break;
      case 5:
        status = "Closed";
        break;
      case 6:
        status = "Reject";
        break;
      case 7:
        status = "Onhold";
        break;
      case 8:
        status = "Withdrawn";
        break;
      case 9:
        status = "Discard";
        break;
      case 10:
        status = "Assign";
        break;
    }
    return status;
  }
Submit_from_date : DateObject;
Submit_end_date : DateObject;
// isfromDateModefied : boolean = false;
// isendDateModified : boolean = false;
  submitfromDate(event){
    this.Submit_from_date = {
      Day : event.getDate(),
      Month : event.getMonth()+1,
      Year : event.getFullYear(),
      Hours : 0,
      Minutes : 0,
      Seconds : 0,
      HasValue : true

    };
  }
  submitendDate(event){
    this.Submit_end_date = {
      Day : event.getDate(),
      Month : event.getMonth()+1,
      Year : event.getFullYear(),
      Hours : 23,
      Minutes : 59,
      Seconds : 59,
      HasValue : true

    }

  }

  assign() {
    const modalRef = this['self'].modalService.open(AssignDialogComponent,{windowClass: 'modal-md modal-full-height modal-right'});
  }

  print() { 
    const modalRef = this.modalService.open(MessageBoxComponent, {
    });
    modalRef.componentInstance.Content={
      operation: { hasOpr: false },
      heading: 'Print Application',
      content: { heading: '', description: printMessage }
    }
  }
  withdraw() {
    const modelRef=this['self'].modalService.open(WithdrawComponent,{windowClass: 'modal-lg modal-full-height modal-right'});
  
  }

  onHold() {
    // let modalRef = this.modalService.open(RejectComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   windowClass: 'modal-md modal-full-height modal-right',
    //   animation: true
    // });
    // modalRef.componentInstance.Content= {
    //   heading: 'On-Hold',
    //   content: null
    // }
  }

  routeModal() {
    this['self'].modalService.open(RouteComponent,{windowClass: 'modal-md modal-full-height modal-right'});
  }

  return() {
    //this['self'].modalService.open(ReturnComponent,{windowClass: 'modal-md modal-full-height modal-right'});
  }

  discard(){
    
  }

  add(){
    if(this['self'].Instruction_Status)
    {
    const ModelRef=  this['self'].modalService.open(IstUserInstructionsModalComponent, {
      backdrop: false,
        keyboard: false,
        windowClass:'modal-vlg modal-right right',
        animation: true
      })
      ModelRef.componentInstance.Content={
        id: ""
      }
    }
  else 
    {
      this['self'].commonService.removeLeftMenu();
      this['self'].dataShare.setApplicationID("");
      this['self'].commonService.appId = "";
      this['self'].commonService.ScreenID="";
      this['self'].commonService.setISTApp(null);
      this['self'].menudata = new ModuleMenu();
      this['self'].menudata.module = "IST";
      this['self'].menudata.operation = "New";
      this['self'].menudata.appId = "";
      this['self'].menudata.formstate = "Draft";
      this['self'].menudata.screenID = "";
      this['self'].header.setHeader(this['self'].menudata);
      this['self'].commonService.setModluleMenu( this['self'].menudata);
      this['self'].router.navigate(['/home/ist/my-applications/application-ext/:0/general_information_request'], { skipLocationChange: true, queryParams: { id:"", app_ext: true, module: "ist",submodule:"ist", screen_type: "my-applications" } })
    }
  }

  getSummaryData() {
    //debugger;
    this.SearchClear();
    this.summaryService.getApplicationSummary("api/ISTMyApplications/GetMyApplicationsList").subscribe(summary => {
      this.rowData = summary["SummaryData"];
      this.studyType = summary["MasterDrops"].MasterData1;
      this.studyType = [{label:"Select",value:"",checked: true}].concat(this.studyType);
      this.TherapeuticAreaList = summary["MasterDrops"].MasterData2;
      this.TherapeuticAreaList=  [{label:"All",value:"", checked: true}].concat(this.TherapeuticAreaList);
      this.productList = summary["MasterDrops"].MasterData3;
      this.productList = [{label:"Select",value:"",checked: true}].concat(this.productList);
      this.Instruction_Status =summary.Instruction_Status;
    });
  }
  getSummarySearch(searchObject: any) {
    this.summaryService.getISTSearchSummary("api/ISTMyApplications/getMySummarySearch", searchObject).subscribe(summary => {
      this.rowData = summary["SummaryData"];
    });
  }

  //// Advace search Functions
  SearchClear() {
    this.IStApplicationsSearch.reset();
  }
  AdvanceSearch() {
    var formData = this.IStApplicationsSearch.value;
    if (formData["StartDate"] != null && formData["StartDate"] != undefined && formData["StartDate"] != 'Invalid Date') 
    {
      //formData["StartDate"] = new Date(formData["StartDate"]);
      formData["StartDateO"] = this.Submit_from_date; 
    }
    if (formData["EndDate"] != null && formData["EndDate"] != undefined && formData["EndDate"] != 'Invalid Date') {
      
     // formData["EndDate"] = new Date(formData["EndDate"]);
      formData["EndDateO"] = this.Submit_end_date;
    }
    this.getSummarySearch(formData);
  }
}
